import { DayBooking } from "../models/dayBooking/dayBooking";
import { DayBookingSaveData } from "../models/dayBooking/dayBookingSaveData";
import { makeApiCallWithAny } from "./tokenService";

export const saveDayBooking = (
    data: DayBookingSaveData
): Promise<DayBooking> => {
    return makeApiCallWithAny<DayBooking>(
        "api/daybooking/save",
        null,
        "POST",
        data,
    );
};

export const getDayBookings = (
    startDate: string,
    endDate: string,
    signal: AbortSignal
): Promise<DayBooking[]> => {
    return makeApiCallWithAny<DayBooking[]>(
        `api/daybooking?startDate=${startDate}&endDate=${endDate}`,
        signal
    );
};

export const deleteDayBooking = (dayBookingId: string): Promise<boolean> => {
    return makeApiCallWithAny<boolean>(
        `api/daybooking/delete/${encodeURIComponent(dayBookingId)}`,
        null,
        "DELETE"
    );
};

export const getDayBooking = (
    dayBookingId: string,
    signal: AbortSignal
): Promise<DayBooking> => {
    return makeApiCallWithAny<DayBooking>(
        `api/daybooking/${encodeURIComponent(dayBookingId)}`,
        signal
    );
};

export const getDayBookingDuration = (
    data: DayBookingSaveData,
    signal?: AbortSignal
): Promise<number> => {
    return makeApiCallWithAny<number>(
        "api/daybooking/duration",
        signal,
        "POST",
        data
    );
};